<div class="modal-header">
  <h2>
    {{cabecalho}}
  </h2>
</div>
<div class="modal-body">
  <label for="justificativa">Informe o motivo do bloqueio:</label>
  <!-- <textarea [formControl]="justificativa" name="justificativa" id="justificativa" rows="2" class="form-control"></textarea> -->
  <div class="column">
    <div class="row">
      <input [formControl]="justificativa" class="input-radio"  id="financeiro" type="radio" value="financeiro" name="justificativa" ngModel>
      <label class="motivo" for="financeiro">Financeiro</label>
    </div>
    <div class="row">
      <input [formControl]="justificativa" class="input-radio"  id="contratual" type="radio" value="contratual" name="justificativa" ngModel>
      <label class="motivo" for="contratual">Contratual</label>
    </div>
  </div>
  <app-msg-erro [control]="justificativa"></app-msg-erro>
</div>
<div class="modal-footer d-flex justify-content-between">
  <button (click)="activeModal.close(false)" class="btn btn-secondary px-lg-5">Cancelar</button>
  <button (click)="activeModal.close(justificativa.value)" [disabled]="justificativa.invalid" class="btn btn-success px-5">Confirmar</button>
</div>
